import React from 'react'
import { Box, Button, Modal, ModalNavHeader, Text, TextInput, FieldLabel } from 'elements'

export default function FileUploadSubmitStep({
  onClose,
  onBack,
  onDone,
  submitting,
  progress,
  reportName,
  setReportName,
}) {
  return (
    <>
      <ModalNavHeader onClose={onClose} titleText="Finish Report" onBack={onBack} />
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        p="xxlarge"
        overflowY="auto"
        pb="xgigantic"
      >
        <Box mb="medium">
          <FieldLabel>Name this report (optional)</FieldLabel>
          <TextInput
            disabled={submitting}
            value={reportName}
            onChange={(event) => setReportName(event.target.value)}
            placeholder="Anomaly Report"
            mb="large"
          />
        </Box>
      </Box>
      <Modal.Footer display="flex" alignItems="center">
        <Button disabled={submitting} mr="medium" kind="secondary" onPress={onDone}>
          {submitting ? 'Creating...' : 'Create Report'}
        </Button>
        <Button disabled={submitting} onPress={onClose} mr="xxxlarge">
          Cancel
        </Button>
        {submitting ? (
          <Box width="100%">
            <Text fontSize="small" color="neutral.1" mb="xsmall">
              Uploading...
            </Text>
            <Box position="relative" height="xsmall" bg="neutral.2" width="100%">
              <Box
                bg="secondary.0"
                position="absolute"
                top="0"
                left="0"
                height="xsmall"
                style={{ transition: 'all 200ms ease' }}
                width={`${progress}%`}
              />
            </Box>
          </Box>
        ) : null}
      </Modal.Footer>
    </>
  )
}
